function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.57465 4.04997L1.51632 15.8333C1.22019 16.3461 1.21842 16.9776 1.51167 17.4921C1.80493 18.0066 2.34916 18.3268 2.94132 18.3333H17.058C17.6501 18.3268 18.1944 18.0066 18.4876 17.4921C18.7809 16.9776 18.7791 16.3461 18.483 15.8333L11.4247 4.04997C11.1225 3.55187 10.5822 3.24768 9.99965 3.24768C9.41708 3.24768 8.87679 3.55187 8.57465 4.04997Z",
  fill: "#EB5757"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M10 8.33334V11.6667",
  stroke: "white",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 10,
  cy: 15,
  rx: 0.937498,
  ry: 0.9375,
  fill: "white"
});

var SvgAlertTriangle = function SvgAlertTriangle(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgAlertTriangle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/alert-triangle.7f7e7ac1.svg";
export { ForwardRef as ReactComponent };